export default "__VITE_ASSET__BtnAMbpT__"